import { ERROR_LOGGING_KEY } from '../common/interfaces';

/**
 * gets an error object with information about the error
 * @param {Components} componentName
 * @param {string} message
 * @param {string} version
 * @returns {ErrorObject} object containing component name, version, and error message
 */
export var getErrorMessage = function getErrorMessage(componentName, message, version) {
  return {
    componentName: componentName,
    errorMessage: "".concat(ERROR_LOGGING_KEY, " - ").concat(message),
    version: version
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/ErrorUtil.js
// module id = 227
// module chunks = 11